import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { catchError, map } from 'rxjs';

@Injectable()
export class MarkupsService extends BaseService {

  constructor(private http: HttpClient) { super(); }

  getPaginadoCombobox(pagina: number, nome: string) {
    return this.http
      .get(this.UrlService + "Markups/GetPaginadoCombobox?pageIndex=" + pagina + "&search=" + encodeURIComponent(nome))
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError));
  }

  getById(id: number) {
    return this.http
      .get(this.UrlService + `Markups/${id}`)
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError));
  }

  getEventoById(id: number) {
    return this.http
      .get(this.UrlService + `Markups/GetEventosMarkup/${id}`)
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError));
  }
}